import React, { Component } from 'react';
import { connect } from 'react-redux';
import Route from './route';
import './App.css';
import './css/bootstrap.min.css'
import './css/style.css'
import './css/splashpopup.css'
import './css/images.css'
import './css/responsive.css'
import './css/jquery.treeview.css'
import './css/font-awesome.min.css'
import './css/print.min.css'
import './fonts/flaticon.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import * as Sentry from "@sentry/react"
// import './fonts/flaticon.css'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render() {
    const notify = (msg, type) => toast[type.toLowerCase() === 'warning' ? 'warn' : type.toLowerCase()](msg);
    return (
      <>
        <Route notify={notify} />
        <ToastContainer theme="colored" autoClose={3000} pauseOnHover={false} />
      </>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(App);// (Sentry.withProfiler(App));
